/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ebr_More_ItemsInputs */

const cs_ebr_more_items = /** @type {(inputs: Ebr_More_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`… a dalších ${i?.count}`)
};

const en_ebr_more_items = /** @type {(inputs: Ebr_More_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`… and ${i?.count} more`)
};

/**
* | output |
* | --- |
* | "… and {count} more" |
*
* @param {Ebr_More_ItemsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_more_items = /** @type {((inputs: Ebr_More_ItemsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_More_ItemsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_more_items(inputs)
	return cs_ebr_more_items(inputs)
});